import { render, staticRenderFns } from "./YoutubeAppSetting.vue?vue&type=template&id=0a281d70&"
import script from "./YoutubeAppSetting.vue?vue&type=script&lang=js&"
export * from "./YoutubeAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports